export function Position(el) {
	// eslint-disable-next-line no-var
	var box = el.getBoundingClientRect();
	// eslint-disable-next-line no-var
	var x = window.pageXOffset;
	// eslint-disable-next-line no-var
	var y = window.pageYOffset;

	return {
		top: box.top + y,
		right: box.right + x,
		bottom: box.bottom + y,
		left: box.left + x,
		width: box.width,
		height: box.height
	};
}
